<script>
export default {
  name: "DowntimeMessageModal",
  methods: {
    close() {
      this.$emit("close")
    },
  },
  props: {
    header: String,
    message: String
  },
}
</script>

<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div
        class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
        @click.stop=""
      >
        <div class="headImgContainer">
          <img src="@/assets/images/maintenance-icon.png" alt="alert icon" width="150" height="150"/>
        </div>
        <header class="modal-header" id="modalTitle">
          <slot name="header"> {{header}} </slot>
        </header>

        <section class="modal-body" id="modalDescription">
          <slot name="body">
            {{message}}
          </slot>
        </section>

        <footer class="modal-footer">
          <button type="button" class="btn-green" @click="close" aria-label="Close modal">
            I Understand
          </button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(253, 247, 242, 0.95);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  box-shadow: rgb(160 170 180 / 40%) 0px 8px 24px;
  border-radius: 3%;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  height: auto;
  width: 95%;
  max-width: 600px;
  padding: 100px 30px;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  justify-content: center;
  position: relative;
  font-weight: 700;
  font-size: 25px;
  color: #333333;
  text-align: center;
}

.modal-footer {
  justify-content: center;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
  text-align: center;

  font-style: normal;
  font-weight: 450;
  font-size: 20px;
  line-height: 150%;

  text-align: center;
  letter-spacing: -0.011em;
}

.btn-close {
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  font-size: 20px;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  color: #333333;
  background: transparent;
}

.btn-green {
  color: #333333;
  background: #fec443;
  border: 1px solid white;
  border-radius: 2px;
  cursor: pointer;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.029em;
  border-radius: 28px;
  height: 40px;
  width: 150px;
}
button:hover,
button:active {
  background-color: #fed67b;
  border-color: white;
}
.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}

.headImgContainer {
  position: relative;
  height: auto;
  text-align: center;
}
</style>
